import { useAuth } from "@/components/Auth";
import { Navigate, Outlet } from "react-router";


const CustomerSupportRoute: React.FC = () => {
    const { currentUser } = useAuth();
    return currentUser?.role?.toLocaleLowerCase() === "admin" || currentUser?.role?.toLocaleLowerCase() === "customersupport" ? (
        <Outlet />
    ) : (
        <Navigate to="/" />
    )
}

export default CustomerSupportRoute;